import { render, staticRenderFns } from "./NewTaller.vue?vue&type=template&id=90086854&"
import script from "./NewTaller.vue?vue&type=script&lang=js&"
export * from "./NewTaller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports